import { generateAvatarInitialsImage } from '@repo/ui';
import { PartnerRequest } from '../../models';
import { TableColumn } from 'react-data-table-component';
import { Badge } from 'reactstrap';

export const makeColumnsPartners = (): TableColumn<PartnerRequest>[] => [
  {
    name: 'Parceiro / Solicitação',
    sortable: true,
    selector: (row) => row.partner.name,
    grow: 2,
    cell: (row) => (
      <div className="d-flex flex-column gap-1 py-2">
        <div className="d-flex align-items-center gap-2">
          <img
            src={
              row.partner.logoKey ||
              generateAvatarInitialsImage(row.partner.name)
            }
            alt={row.partner.name}
            className="rounded-circle object-fit-cover flex-shrink-0"
            style={{ width: 36, height: 36 }}
          />
          <strong className="fs-6">{row.partner.name}</strong>
        </div>
        <p className="text-muted mb-0 ms-1" style={{ fontSize: 13 }}>
          {row.description}
        </p>
      </div>
    ),
  },
  {
    name: 'Dados solicitados',
    grow: 3,
    wrap: true,
    cell: (row) => (
      <div className="d-flex flex-wrap gap-1 py-2">
        {row.requestedData.map((field) => (
          <Badge
            key={field.key}
            color={field.mandatory ? 'primary' : 'light'}
            className={field.mandatory ? '' : 'text-dark border'}
            pill
            style={{ fontSize: 11 }}
          >
            {field.title}
            {field.mandatory && ' *'}
          </Badge>
        ))}
      </div>
    ),
  },
  {
    name: 'Chave',
    sortable: true,
    selector: (row) => row.key,
    width: '140px',
    cell: (row) => (
      <code
        style={{
          background: '#f1f3f5',
          padding: '2px 8px',
          borderRadius: 4,
          fontSize: 12,
        }}
      >
        {row.key ? row.key.toUpperCase() : ''}
      </code>
    ),
  },
  {
    name: 'URL',
    selector: (row) => row.redirectUrl,
    wrap: true,
    width: '200px',
    cell: (row) =>
      row.redirectUrl ? (
        <span
          className="text-muted"
          style={{ fontSize: 12 }}
          title={row.redirectUrl}
        >
          {row.redirectUrl}
        </span>
      ) : (
        <span className="text-muted">—</span>
      ),
  },
  {
    name: 'Status',
    sortable: true,
    selector: (row) => (row.active ? 'Ativo' : 'Inativo'),
    width: '110px',
    cell: (row) => (
      <Badge color={row.active ? 'success' : 'secondary'} pill>
        {row.active ? 'Ativo' : 'Inativo'}
      </Badge>
    ),
  },
];
